import { cn } from '@/lib/cn';

interface Option<T extends string> {
  value: T;
  label: string;
}

/** Radio-style segmented control, e.g. language or theme. */
export function Segmented<T extends string>({
  value,
  options,
  onChange,
  label,
}: {
  value: T;
  options: Option<T>[];
  onChange: (v: T) => void;
  label: string;
}) {
  return (
    <div role="radiogroup" aria-label={label} className="inline-flex rounded-control border border-line bg-surface-2 p-1">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={o.value === value}
          onClick={() => onChange(o.value)}
          className={cn(
            'min-h-11 min-w-11 rounded-[8px] px-3 text-sm font-medium transition-colors',
            o.value === value ? 'bg-accent text-accent-fg' : 'text-muted hover:text-fg',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
